import React from "react";
import { ListTable, ListTableColumn, createListTableColumns, renderJoined, ErrorMessage } from "sprint-common-web";

import { GroupedFailures } from "../../useImportOrdersForm";

interface BuzzOrderValidationFailedSummaryProps {
    groupedCloudOrdersFailures: GroupedFailures[];
    columnsFailures: string[];
    fileMetadataFailures: string[];
}

export const BuzzOrderValidationFailedSummary: React.FC<BuzzOrderValidationFailedSummaryProps> = ({
    groupedCloudOrdersFailures,
    columnsFailures,
    fileMetadataFailures
}: BuzzOrderValidationFailedSummaryProps) => {
    const columns: ListTableColumn<GroupedFailures>[] = createListTableColumns<GroupedFailures>([
        {
            type: "basic",
            name: "Id",
            key: "code",
            minWidth: 60,
            maxWidth: 60
        },
        {
            type: "basic",
            name: "Failures",
            key: "failures",
            minWidth: 1500,
            maxLenght: 200,
            isMultiline: true,
            onRender: renderJoined
        }
    ]);

    const fileMetadataFailuresView = fileMetadataFailures.length > 0 ? renderFailures(fileMetadataFailures) : null;

    const columnsFailuresView = columnsFailures.length > 0 ? renderFailures(columnsFailures) : null;

    const cloudOrdersFailuresView =
        groupedCloudOrdersFailures.length > 0 ? (
            <ListTable
                columns={columns}
                items={groupedCloudOrdersFailures}
                isLoading={false}
                layoutMode="fixedColumns"
            />
        ) : null;

    return (
        <>
            <ErrorMessage text="Validation failed" />
            {fileMetadataFailuresView}
            {columnsFailuresView}
            {cloudOrdersFailuresView}
        </>
    );
};

const renderFailures = (failures: string[]): JSX.Element => {
    return (
        <>
            {failures.map((failure) => (
                <ErrorMessage key={failure} text={failure} />
            ))}
        </>
    );
};
